import styled from 'styled-components';

export const Container = styled.div`

    flex: 1;
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
    display: grid;
  }
`
export const UserBoughtContainer = styled.div`

    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top:40px;

`
export const UserBoughtLeftContainer = styled.div`
    border: 3px solid #7e7d7a;


    display: flex;
    flex-direction: column;
    margin-right:50px;
    width:25%;
    height:60%;
    border-radius: 15px;

    i{
            margin:8px 8px;
            font-size:40px;

        }
`
export const PerfilPictureContainer = styled.div`

    .perfil-picture-background{
            border-radius: 50%;
            border:6px solid black;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 251px;
            height: 251px;
            margin: 20px 50px;
    }

        img{
            width: 244px;
            height: 244px;
            border-radius:50%;
            }

`
export const UserBoughtFeatureContainerBotton = styled.div`

    display:flex;
    align-items:flex-start;
    flex-direction:column;
    margin:30px;


`
export const PerfilNameSinceContainer = styled.div`

    .user-name-container{
            display: flex;
            align-items: center;
            justify-content: center;
            color: #002666;
            font-weight:bold;
    }

    .user-since-container{
            display: flex;
            align-items: center;
            justify-content: center;
            color:#535353;
            font-weight:bold;
            font-size:12px;

    }

`
export const MySellerContainer = styled.div`

        margin-top:10px;

    .my-seller{
        color:#303030;
        font-size:25px;
        display: flex;
        align-items: center;
        justify-content: center;
    }


    .my-seller-secondary-property{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin:20px;
        list-style:none;
    }
`
export const MyPurchaseContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;


`
export const PaymentContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const ConfigurationContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const UserBoughtRightContainer = styled.div`
    border: 2px solid gray;
    flex: 1;
    display: flex;
    flex-direction: column;
    border-radius:15px;
`

export const UserBoughtTitleContainer = styled.div`


        border-bottom: 2px solid gray;
        display: flex;
        flex-direction:row;
        align-items: flex-end;
        justify-content: space-between;
        margin: 20px;


    .user-title-bought{
        color: #002666;
        font-size: 26px;
        margin-bottom:6px;
        i{
            font-size:40px;
            margin-right: 20px;
        }
    }

    span{
        color: #002666;
    }
    .user-secundary-title{
        color:#002666;
        margin-bottom:6px;
    }

`

export const UserContainerItensStatus = styled.div`

        background-color:lightgray;
        border-radius:15px;
        justify-content: space-between;
        display: flex;
        flex-direction:row;
        padding: 5px 10px;
        margin: 10px 20px;

        .product-picture{
            margin: 2px 8px 2px 12px;

            img{
                width: 150px;
                height: auto;
                margin: 5px;
                border-radius:15px;
            }
        }

        .description-general{

            display: flex;
            flex-direction: column;

            .USC-data{

            }
            .USC-description-product{
                color:red;
            }
            .USC-description-status{
                color:red;
            }
            .USC-description-price{
                font-weight: bold;
            }

        }

        .delivery-status{
            color: #e49300;
            display:flex;
            align-items: center;

            i{
                font-size: 24px;
                margin-right:3px;
            }
        }

            .product-status-btn-icon{
                color: black;
                border:black;
                background-color: gray;
                border-radius: 5px;
                margin:10px;
            }

            .product-status-btn-icon:hover{
                color: darkgrey;
                border:darkgrey;
                background-color: lightgray;
            }
`

export const UserContainerStatusDelivery = styled.div`

    display: none;
    flex-direction:column;
    background-color: #535353;
    justify-content: space-between;
    margin: -20px 20px 20px 20px;
    z-index:-1;
    padding-top:20px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    .status-delivery-row{
        display: flex;
        flex-direction:row;
        align-items: center;
        font-weight:bold;
        color:white;
        font-size:20px;
        padding: 0 20px;
    }

   .status-delivery-row-left{
        display: flex;
        flex-direction:column;
        align-items: flex-start;
        width:12%;
   }

   .status-delivery-row-mid{
        width:10%;
   }

   .status-delivery-row-right{
        width:78%;


        p{
            margin:0;
        }

        span{
            font-size:16px;
        }
   }

    i{
        font-size: 35px;
        display: flex;
        color:#535353;
    }

    .user-bought-icon-background{

        border-radius: 50%;
        display: flex;
        background-color: white;
        align-items: center;
        justify-content: center;
        width: 55px;
        height: 55px;
        margin: 15px;
    }
`
